import { render, staticRenderFns } from "./GetSelectedDispatchesList.vue?vue&type=template&id=96d102fc&scoped=true&"
import script from "./GetSelectedDispatchesList.vue?vue&type=script&lang=js&"
export * from "./GetSelectedDispatchesList.vue?vue&type=script&lang=js&"
import style0 from "./GetSelectedDispatchesList.vue?vue&type=style&index=0&id=96d102fc&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d102fc",
  null
  
)

export default component.exports